<template>
  <div class="fast-reply">
    <!--快捷回复管理页面  -->
    <div class="title">个人详情留言管理</div>
    <div class="btn">
      <el-button @click="addShow = true">新增</el-button>
      <el-button @click="back">返回</el-button>
    </div>
    <div>
      <el-table :data="messageTableData" border style="width: 100%">
        <el-table-column prop="content" label="留言内容"> </el-table-column>

        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span>{{
              scope.row.status == 0
                ? "已下架"
                : scope.row.status == 1
                ? "已发布"
                : ""
            }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="operation" label="操作">
          <template slot-scope="scope">
            <el-popconfirm
              v-if="scope.row.status == 1"
              :title="'确定要下架该快捷回复吗？'"
              @confirm="xjMessage(scope.row)"
            >
              <el-button slot="reference" type="text">下架</el-button>
            </el-popconfirm>
            <el-button @click="editMessage(scope.row)" type="text"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="paging">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="pagination.total"
        @current-change="handleCurrentChange"
        :page-size="pagination.pageSize"
        :current-page="pagination.page"
      >
      </el-pagination>
    </div>
    <!--  快捷回复编辑页面-->
    <div class="message-edit">
      <el-dialog title="留言编辑" :visible.sync="editShow" width="30%">
        <div class="dialog-content">
          <el-input
            type="textarea"
            autosize
            resize="none"
            placeholder="请输入内容"
            v-model="editTextarea"
          >
          </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editShow = false">取 消</el-button>
          <el-button type="primary" @click="confirmEdit">确 定</el-button>
        </span>
      </el-dialog>
    </div>

    <!--  快捷回复新增页面-->
    <div class="message-edit">
      <el-dialog title="留言编辑" :visible.sync="addShow" width="30%">
        <div class="dialog-content">
          <el-input
            type="textarea"
            autosize
            resize="none"
            placeholder="请输入内容"
            v-model="addTextarea"
          >
          </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addShow = false">取 消</el-button>
          <el-button type="primary" @click="confirmAdd">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  fastReplyListApi,
  replyCreateApi,
  fastReplyUpdateApi,
} from "@/api/open";
export default {
  props: {},
  data() {
    return {
      pagination: {
        page: 1,
        total: 0,
        pageSize: 10,
      },
      inputHandle: {},
      addShow: false,
      messageTableData: [],
      addTextarea: "" /* 新增绑定值 */,
      editShow: false,
      editTextarea: "" /* 编辑绑定值 */,
    };
  },
  methods: {
    //   编辑快捷回复
    editFastReply() {
      let params = {
        id: this.inputHandle.id,
        status: 1,
        content: this.editTextarea,
      };
      fastReplyUpdateApi(params).then((res) => {
        this.$message.success(res.msg);
        this.editShow = false;
        this.fastReplyList();
      });
    },

    //   编辑确定
    confirmEdit() {
      if (this.editTextarea == "") {
        this.$message.error("快捷回复内容不能为空");
        return false;
      } else {
        this.editFastReply();
      }
    },
    //   新增快捷回复
    addFastReply() {
      let params = {
        status: 1,
        content: this.addTextarea,
      };
      replyCreateApi(params).then((res) => {
        this.$message.success(res.msg);
        this.addShow = false;
        this.fastReplyList();
        this.addTextarea="";
      });
    },
    // 新增确定
    confirmAdd() {
      if (this.addTextarea == "") {
        this.$message.error("快捷回复内容不能为空");
        return false;
      } else {
        this.addFastReply();
      }
    },
    // //分页选择
    handleCurrentChange(page) {
      this.pagination.page = page;
      this.fastReplyList();
    },
    //   获取快捷回复列表
    fastReplyList() {
      let params = {
        pageNum: this.pagination.page,
        pageSize: this.pagination.pageSize,
      };
      fastReplyListApi(params).then((res) => {
        this.messageTableData = res.data.list;
        this.pagination.page = res.data.pageNum;
        this.pagination.total = res.data.total;
        this.pagination.pageSize = res.data.pageSize;
      });
    },
    //   返回上一页
    back() {
      this.$emit("backAudit", true);
    },
    //   下架
    xjMessage(row) {
      let params = {
        id: row.id,
        status: 0,
      };
      fastReplyUpdateApi(params).then((res) => {
        this.$message.success(res.msg);
        this.fastReplyList();
      });
    },
    //   编辑快捷回复
    editMessage(row) {
      this.editShow = true;
      this.editTextarea = row.content;
      this.inputHandle = row;
    },
  },
  mounted() {
    this.fastReplyList();
  },
};
</script>

<style lang="scss" scoped>
.fast-reply {
  .title {
    color: rgba(102, 102, 102, 100);
    font-size: 20px;
    margin-bottom: 15px;
  }
  .paging {
    text-align: right;
    margin-top: 10px;
  }
  .btn {
    margin-bottom: 10px;
  }
  .message-detail {
    .dialog-content {
      .content-header {
        p {
          font-size: 16px;
          margin-bottom: 5px;
        }
      }
      .content-item {
        margin-top: 10px;
        .item-header {
          display: flex;

          p {
            font-size: 16px;
            margin-bottom: 5px;
          }
          p:nth-of-type(2) {
            margin-top: 2px;
            margin-left: 10px;
            font-size: 14px;
          }
        }
      }
      .el-input {
        display: flex;
        align-items: center;
        .edit {
          margin-left: 10px;
          margin-right: 10px;
          font-size: 16px;
          cursor: pointer;
        }
        .del {
          font-size: 16px;
          cursor: pointer;
        }
      }
      .content {
        p {
          margin-top: 40px;
          font-size: 16px;
          margin-bottom: 5px;
        }
      }
    }
    /deep/ .el-textarea {
      width: 400px;
    }
  }
}
</style>